export default Backbone.View.extend({
  events: {
    click: 'disableFilter',
  },

  initialize(options) {
    this.fieldName = options.fieldName;
    this.model.on(`change:${this.fieldName}`, _.bind(this.onFieldChanged, this));
  },

  onFieldChanged() {
    if (this.model.get(this.fieldName)) {
      this.$el.removeClass('hidden');
    } else {
      this.$el.addClass('hidden');
    }
  },

  disableFilter() {
    this.model.set(this.fieldName, false);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/applied_filter_pill_view.js